/**
파일명: contactFormValidation.js
설명: 문의 작성 폼의 필수값/형식 검증 로직을 담당합니다.
*/

import {
  contactPattern,
  initialErrors,
  requiredFieldLabels,
} from '../constants/contactFormConstants';
import { getPlainMessage, hasAnyError } from './contactFormTransformers';

/**
// [비즈니스] 문의 등록 전에 필수 입력과 형식을 검증해 무효 요청 전송을 방지합니다.
// [기능] formState를 받아 에러 맵, 유효 여부, 정규화된 plainMessage를 반환합니다.
// [기술] 필수 필드 루프 검증 + 연락처 패턴 검증 + 개인정보 동의 검증을 한 번에 수행합니다.
*/
export function validateFormState(formState) {
  const plainMessage = getPlainMessage(formState.message);
  const nextErrors = { ...initialErrors };

  Object.entries(requiredFieldLabels).forEach(([field, label]) => {
    const value = field === 'message' ? plainMessage : (formState[field] ?? '').trim();
    if (!value) {
      nextErrors[field] = `${label}은(는) 필수 입력 항목입니다.`;
    }
  });

  if (!nextErrors.contact && !contactPattern.test(formState.contact.trim())) {
    nextErrors.contact = '연락처는 숫자와 하이픈만 사용합니다.';
  }

  if (!formState.privacyAgreed) {
    nextErrors.privacyAgreed = '개인정보 수집 및 이용 동의가 필요합니다.';
  }

  return {
    nextErrors,
    isValid: !hasAnyError(nextErrors),
    plainMessage,
  };
}
